import { s as setMode } from './index-6b6bf75d.js';
import { U as UUID, g as getColorShade, s as setColorShade } from './color-bb423d4f.js';
import { F as FileManager, S as ScrollSpy, v as validator } from './validator-7a36417b.js';

const handleMediaQuery = (event) => {
  if (event.media !== '(prefers-color-scheme: dark)')
    return;
  const pref = getColorScheme();
  const color = pref === 'auto' ? (event.matches ? 'dark' : 'light') : pref;
  document.documentElement.setAttribute('color-scheme', color);
};
const initColorScheme = () => {
  const match = window.matchMedia('(prefers-color-scheme: dark)');
  match.addEventListener
    ? match.addEventListener('change', handleMediaQuery)
    : match.addListener(handleMediaQuery);
  handleMediaQuery(match);
};
const getColorScheme = () => {
  const preference = localStorage.getItem('bce-color-scheme');
  return preference ? preference : 'auto';
};
const setColorScheme = (scheme) => {
  if (scheme === 'dark' || scheme === 'light') {
    localStorage.setItem('bce-color-scheme', scheme);
    document.documentElement.setAttribute('color-scheme', scheme);
  }
  else {
    localStorage.removeItem('bce-color-scheme');
    const match = window.matchMedia('(prefers-color-scheme: dark)');
    handleMediaQuery(match);
  }
};

const bce = {
  file: FileManager.inMemory(),
  FileManager,
  generateId: () => UUID.v4(),
  getColorScheme: getColorScheme,
  getColorShade,
  setColorScheme: setColorScheme,
  setColorShade,
  ScrollSpy,
  validator
};
const main = () => {
  // Setup global config
  window.BCE = window.BCE || bce;
  initColorScheme();
  setMode(el => {
    // Component specific mode's (e.g. bce-button within bce-fab)
    if (chain(el, 'bce-button', 'bce-fab'))
      return 'fab';
    if (chain(el, 'bce-button', 'bce-menu'))
      return 'menu';
    if (chain(el, 'bce-link', 'bce-link'))
      return 'link';
    if (chain(el, 'bce-link', 'bce-nav', 'bce-header'))
      return 'header';
    if (chain(el, 'bce-nav', 'bce-header'))
      return 'header';
    if (chain(el, 'bce-nav', 'bce-side-bar'))
      return 'sidebar';
    const root = el.closest('bce-root');
    return el.getAttribute('mode') || (root && root.mode) || 'regular';
  });
};
const chain = (el, child, ...parents) => {
  if (!el.matches(child))
    return false;
  for (const parent of parents) {
    const cur = el.parentElement;
    if (!cur || !cur.matches(parent))
      return false;
    el = cur;
  }
  return true;
};

const globalScripts = main;

export { globalScripts as g };
